import ContractCoverageIndicator from './ContractCoverageIndicator';

export default ContractCoverageIndicator;
